import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ActivityFeed = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'approved':
        return { icon: 'CheckCircle', color: 'text-success', bgColor: 'bg-success/20', borderColor: 'border-success/40' };
      case 'rejected':
        return { icon: 'XCircle', color: 'text-error', bgColor: 'bg-error/20', borderColor: 'border-error/40' };
      case 'viewed':
        return { icon: 'Eye', color: 'text-info', bgColor: 'bg-info/20', borderColor: 'border-info/40' };
      case 'feedback':
        return { icon: 'MessageSquare', color: 'text-warning', bgColor: 'bg-warning/20', borderColor: 'border-warning/40' };
      case 'shared':
        return { icon: 'Share', color: 'text-primary', bgColor: 'bg-primary/20', borderColor: 'border-primary/40' };
      default:
        return { icon: 'Circle', color: 'text-muted-foreground', bgColor: 'bg-muted/20', borderColor: 'border-muted/40' };
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const diff = now - new Date(timestamp);
    const minutes = Math.floor(diff / (1000 * 60));
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    
    if (days > 0) return `${days}d ago`;
    if (hours > 0) return `${hours}h ago`;
    if (minutes > 0) return `${minutes}m ago`;
    return 'Just now';
  };

  return (
    <div className="space-y-6">
      <div className="space-y-6 max-h-96 overflow-y-auto">
        {activities?.map((activity, index) => {
          const { icon, color, bgColor, borderColor } = getActivityIcon(activity?.type);
          
          return (
            <div key={activity?.id} className="bg-gradient-to-r from-card/50 to-muted/10 border-2 border-border/40 rounded-lg p-4 hover:shadow-md transition-luxury">
              <div className="flex items-start space-x-4">
                <div className={`w-12 h-12 rounded-xl border-2 ${bgColor} ${borderColor} flex items-center justify-center flex-shrink-0 shadow-sm ${color}`}>
                  <Icon name={icon} size={20} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between mb-2">
                    <div className="flex items-center space-x-3">
                      <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0 border-2 border-accent/30">
                        <Image 
                          src={activity?.clientAvatar} 
                          alt={activity?.clientName}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <span className="font-heading text-foreground text-sm">{activity?.clientName}</span>
                    </div>
                    <span className="text-xs text-foreground/60 bg-muted/30 border border-muted/50 rounded-full px-2 py-1">{formatTimeAgo(activity?.timestamp)}</span>
                  </div>
                  
                  <p className="text-sm text-foreground/70 mb-2 font-medium">{activity?.description}</p>
                  
                  {activity?.projectName && (
                    <div className="bg-accent/10 border border-accent/30 rounded-lg px-3 py-1 inline-block mb-2">
                      <p className="text-xs text-accent font-bold">Project: {activity?.projectName}</p>
                    </div>
                  )}
                  
                  {activity?.feedback && (
                    <div className="bg-gradient-to-r from-muted/30 to-muted/20 border-2 border-muted/50 rounded-lg p-3">
                      <p className="text-xs text-foreground/65 italic font-medium">
                        "{activity?.feedback}"
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {activities?.length === 0 && (
        <div className="text-center py-8 bg-gradient-to-br from-muted/10 to-muted/20 border-2 border-dashed border-muted/40 rounded-xl">
          <div className="w-16 h-16 bg-gradient-to-br from-muted/30 to-muted/20 border-2 border-muted/50 rounded-xl flex items-center justify-center mx-auto mb-4">
            <Icon name="Activity" size={32} className="text-muted-foreground" />
          </div>
          <h3 className="text-lg font-heading text-foreground mb-2">No Recent Activity</h3>
          <p className="text-foreground/70 font-medium">Client interactions will appear here</p>
        </div>
      )}
    </div>
  );
};

export default ActivityFeed;